import { Component, OnInit } from '@angular/core';
import { userCallbackParam, asQueryString } from 'src/app/models/user-params-models';
import { ActivatedRoute, Router } from '@angular/router';
import { IpService } from 'src/app/services/ip.service';
import { RdService } from 'src/app/services/rd.service';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { timer, Observable } from 'rxjs';
import { takeWhile, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-survey-callback',
  templateUrl: './survey-callback.component.html',
  styleUrls: ['./survey-callback.component.css']
})
export class SurveyCallbackComponent implements OnInit {
  userParam: userCallbackParam = {
    TOID: '0',
    Status: 0,
    SubId: '0',
    IP: '0',
    referrer: ''
  };
  counter = 1800;
  tick = 1000;
  timeRemaining;
  next_Message: string = '';
  user_Message: string;
  user_Status: number = -1;
  private storageKey!: string;
  isValid: boolean = true; // Property to track submission
  isProcessing: boolean = false; // Track if processing is happening
  NoPromotion: boolean = false;
  constructor(private router: Router, private route: ActivatedRoute, private ipService: IpService, private rdInfoCheckService: RdService, private loaderService: LoaderService) { }
  source: string = '';
  ngOnInit(): void {
    this.handleSurveyCallBackResponse();
  }

  private getPendingMessageKey(): string {

    return localStorage.getItem(this.storageKey) as string;
  }

  async saveSurveyUserTempData(pageName?: string): Promise<void> {
    try {
      if (this.userParam.IP) {
        const tempDataUrl = this.rdInfoCheckService.getSurveyUserTempDataSaveUrl();
        const payload = {
          tforid: '0',
          utype: '0',
          qparm: asQueryString(this.userParam.TOID, '0'),
          uid: '',
          rcid: '0',
          mode: 'Live',
          ip: this.userParam.IP,
          devicetype: 0,
          policy: 0,
          tierid: 0,
          decisionCode: 0,
          serviceType: 0,
          activityToken: '',
          surveyId: 0,
        }
        const jsonData = JSON.stringify(payload);
        const blob = new Blob([jsonData], { type: 'application/json' });

        const success = navigator.sendBeacon(`${tempDataUrl}/${pageName}`, blob);
        if (!success) {
          console.warn('Beacon request failed, attempting fetch fallback.');
          const response = await fetch(`${tempDataUrl}/${pageName}`, {
            method: 'POST',
            body: blob,
            headers: { 'Content-Type': 'application/json' },
          });

          if (!response.ok) {
            throw new Error(`Fetch failed with status ${response.status}`);
          }
        }
      }
    } catch (error) {
      console.error('Error saving survey user temp data:', error);
    }
  }

  handleSurveyCallBackResponse(): void {
    this.route.queryParams.subscribe(params => {
      this.userParam.TOID = params['TOID'] === undefined ? '0' : asQueryString(params['TOID'], '0');
      this.userParam.Status = params['s'] === undefined ? 0 : Number(asQueryString(params['s'], '0'));
      this.userParam.SubId = params['subid'] === undefined ? '0' : asQueryString(params['subid'], '0');
      const ref = params['ref'] === undefined ? '' : asQueryString(params['ref'], '');
      this.userParam.referrer = ref === '' ? 'Client' : ref === 's' ? 'Scrip8' : ref === 'y' ? 'Yoda' : 'Client';
    });

    //5s
    if (this.userParam.TOID != '0' || this.userParam.SubId != '0') {
      this.loaderService.show();
      this.ipService.getIPAddresss().subscribe((res: any) => {
        this.userParam.IP = res.ip;
        // this.storageKey = `callback_${this.userParam.TOID}`;
        // if ('Callback_VIEW' !== this.getPendingMessageKey()) {
        //   const newKey = `callback_${this.userParam.TOID}`;
        //   // Object.keys(localStorage).forEach(key => {
        //   //   if (key.startsWith('opinionest_status_')) {
        //   //     localStorage.removeItem(key);
        //   //   }
        //   // });
        //   localStorage.setItem(newKey, 'Callback_VIEW');
        //   this.sendAndMarkSent(`InProgress-Yoda-Landed on Callback Page, status=${this.userParam.Status} and ref=${this.userParam.referrer}`,this.userParam.TOID);

        // }
        const rdInfoUrl = this.rdInfoCheckService.getSurveyCallBackUrl();
        this.rdInfoCheckService.postData(this.userParam, rdInfoUrl).subscribe({
          next: (response: HttpResponse<any>) => {
            // debugger;
            this.loaderService.hide();
            this.isProcessing = false;
            this.isValid = true;
            const responseData = response.body.data;
            this.NoPromotion = Boolean(responseData.NoPromotion || responseData.noPromotion || responseData.nopromotion || responseData.Nopromotion);
            sessionStorage.setItem("NoPromotion", String(this.NoPromotion));
            this.user_Status = responseData.status;
            this.user_Message = responseData.message;

            const isNoPromo = this.NoPromotion === true || this.NoPromotion == Boolean('true') || this.NoPromotion == Boolean(1);

            if (responseData.doRedirect) {

              // 🚀 CASE 1: No Promotion → instant redirect
              if (isNoPromo) {
                this.next_Message = "Redirecting...";

                if (responseData.redirectLink != '') {
                  window.location.href = responseData.redirectLink;
                }
                return;
              }

              // ⏳ CASE 2: Normal flow → 5 sec timer
              const source = timer(5, 1000);
              source.subscribe(val => {
                this.next_Message = "Redirecting in " + ((5 - val) <= 0 ? 0 : 5 - val) + " sec....";
              });
              setTimeout(() => {
                // debugger;
                if (responseData.redirectLink != '') {
                  window.location.href = responseData.redirectLink;
                }
                else {
                  //  this.next_Message="If you want to report any issue please Contact Us.Some thing went wrong during redirect."
                }
              }, 5000);
            }
          },
          error: (error: HttpErrorResponse) => {
            // debugger;
                  this.loaderService.hide();
            if (error.error.data != undefined) {
              this.user_Message = error.error.data.message;
              this.user_Status = error.error.data.status;
              this.isProcessing = false;
              this.isValid = false;
            }
            else {
              this.user_Message = "Internal server error";
              this.user_Status = 5;
              this.isProcessing = false;
              this.isValid = false;
            }

          }
        });
      });
    }
    else {
      this.user_Status = 0;
      this.user_Message = "Invalid user";
            this.loaderService.show();
    }
  }


  private async sendAndMarkSent(
    message: any,
    logId: any,
  ): Promise<void> {

    try {
      await fetch(`${environment.baseUrl}callbacks/TrackUpdate`, {
        method: 'POST',
        body: JSON.stringify({ toid: logId, message, mode: 1 }),
        headers: { 'Content-Type': 'application/json' },
        keepalive: true
      });
    } catch {
      // do nothing — redirect should still happen
      try {
        await this.saveSurveyUserTempData('InProgress-Yoda-Error: In Track Update on Callback Page')
      } catch { }
    }
  }
}
